export const GET_ATTENDANCE_LIST_QUERY = `
  query getAttendanceList($workshopId: DocumentId!) {
    getAttendanceList(workshopId: $workshopId) {
      __typename

      ... on AttendanceList {
        results {
          isActive
          officerId
        }
      }
    }
  }
`;
export const GET_OFFICER_LOOKUP_QUERY = `
  query getOfficerLookup($county: String!, $queryString: String!, $count: Int!, $after: String) {
    getOfficerLookup(county: $county, queryString: $queryString, count: $count, after: $after) {
      __typename

      ...on OfficerLookupData {
        officers {
          id
          fullName
          firstName
          lastName
          email
          phone
        }
        count
      }
    }
  }
`;
export const GET_TRAINING_CLEARANCES_QUERY = `
  query getTrainingClearances($county: String!, $officerId: String!) {
    getTrainingClearances(county: $county, officerId: $officerId) {
      __typename

      ...on ClearanceData {
        editClearance
        trainingClearance
      }
    }
  }
`;
export const GET_WORKSHOP_RECORDS_QUERY = `
  query getWorkshopRecords($officerId: String!, $county: String!, $sort: SortType!) {
    getWorkshopRecords(officerId: $officerId, county: $county, sort: $sort) {
      __typename

      ...on RecordSummary {
        records {
          id
          isActive
          startDate
          endDate
          hoursType
          workshopName
          hoursLogged
          comments
          createdBy
          createdDate
          workshopId
        }
      }
    }
  }
`;
